module.exports = __webpack_public_path__ + "static/img/slideimg.566443a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideimg.jpg
// module id = NRYs
// module chunks = 0